import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'

export type ChooseAudioModalTranslations = {
  title: string
  uploadNew?: string
  loading?: string
  selectAudio: string
}

export const chooseAudioModalId: TmWrappers = 'chooseAudioModal'
export const chooseAudioTable = 'chooseAudioTable' as RegisteredServices

export const forwardAudioFileFormats = {
  '.mp3': 'audio/mpeg', // eslint-disable-line @typescript-eslint/naming-convention
  '.wav': 'audio/wav', // eslint-disable-line @typescript-eslint/naming-convention
}
